import React from 'react';

export default function App() {
  return (
    <div style={styles.page}>
      
      {/* Μπάρα Πλοήγησης - Καρφωμένη στην κορυφή */}
      <nav style={styles.nav}>
        <div style={styles.logo}>
          <span style={styles.logoIcon}>💧</span>
          <span style={styles.logoText}>Pro<span style={{color: '#EA580C'}}>Plumber</span> Thess</span>
        </div>
        <a href="tel:6900000000" style={styles.navPhone}>
          <span style={styles.pulsingDot}></span>
          📞 6900 000 000
        </a>
      </nav>

      {/* Hero Section - Το πρώτο πράγμα που βλέπει ο πελάτης */}
      <header style={styles.hero}>
        <div style={styles.heroContent}>
          <div style={styles.badge}>🚨 24/7 Εξυπηρέτηση στη Θεσσαλονίκη</div>
          <h1 style={styles.heroTitle}>
            Βλάβη; Είμαστε στον χώρο σας σε <span style={styles.highlight}>15 λεπτά!</span>
          </h1>
          <p style={styles.heroSubtitle}>
            Αδειούχοι υδραυλικοί για άμεσες επισκευές, αποφράξεις, φυσικό αέριο και ανακαινίσεις. Εγγυημένη εργασία, χωρίς κρυφές χρεώσεις.
          </p>
          <div style={styles.heroButtons}>
            <a href="tel:6900000000" style={styles.ctaButtonPrimary}>
              Καλέστε Τώρα
            </a>
            <a href="#services" style={styles.ctaButtonSecondary}>
              Δείτε Υπηρεσίες
            </a>
          </div>
        </div>
      </header>

      {/* Trust Factors (Γιατί να μας επιλέξει) */}
      <div style={styles.trustSection}>
        <div style={styles.trustItem}>
          <div style={styles.trustIcon}>⏱️</div>
          <strong>Άφιξη σε 15' - 30'</strong>
          <span style={styles.trustText}>Σε όλο το κέντρο & ανατολικά</span>
        </div>
        <div style={styles.trustItem}>
          <div style={styles.trustIcon}>🛡️</div>
          <strong>2 Χρόνια Εγγύηση</strong>
          <span style={styles.trustText}>Σε όλα τα ανταλλακτικά</span>
        </div>
        <div style={styles.trustItem}>
          <div style={styles.trustIcon}>💶</div>
          <strong>Διαφανείς Τιμές</strong>
          <span style={styles.trustText}>Ξέρετε το κόστος από πριν</span>
        </div>
      </div>

      {/* Βασικές Υπηρεσίες */}
      <main id="services" style={styles.main}>
        <h2 style={styles.sectionTitle}>Οι Εξειδικεύσεις Μας</h2>
        <div style={styles.grid}>
          
          <div style={styles.card}>
            <div style={styles.cardIcon}>🔧</div>
            <h3 style={styles.cardTitle}>Επείγουσες Βλάβες</h3>
            <p style={styles.cardText}>Εντοπισμός & επισκευή διαρροών, σπασμένοι σωλήνες, καζανάκια, μπαταρίες. Άμεση λύση στο πρόβλημα.</p>
          </div>

          <div style={styles.card}>
            <div style={styles.cardIcon}>🔥</div>
            <h3 style={styles.cardTitle}>Φυσικό Αέριο & Θέρμανση</h3>
            <p style={styles.cardText}>Εγκατάσταση και συντήρηση λέβητα φυσικού αερίου, συντήρηση καλοριφέρ, ενδοδαπέδια θέρμανση.</p>
          </div>

          <div style={styles.card}>
            <div style={styles.cardIcon}>☀️</div>
            <h3 style={styles.cardTitle}>Ηλιακοί & Boiler</h3>
            <p style={styles.cardText}>Τοποθέτηση, service και επισκευή ηλιακών και ηλεκτρικών θερμοσιφώνων. Δωρεάν μελέτη χώρου.</p>
          </div>

          <div style={styles.card}>
            <div style={styles.cardIcon}>🚿</div>
            <h3 style={styles.cardTitle}>Ανακαινίσεις Μπάνιου</h3>
            <p style={styles.cardText}>Ολική αντικατάσταση δικτύων, νέα είδη υγιεινής. Παραδίδουμε το μπάνιο των ονείρων σας με το κλειδί στο χέρι.</p>
          </div>

        </div>
      </main>

      {/* Ενότητα Προσφορών / Τιμών (Αυτό που ψάχνουν οι πελάτες) */}
      <section style={styles.offersSection}>
        <h2 style={styles.sectionTitleWhite}>Ενδεικτικές Προσφορές</h2>
        <div style={styles.offersGrid}>
          <div style={styles.offerCard}>
            <h4>Επισκευή Διαρροής / Καζανάκι</h4>
            <div style={styles.price}>Από 30€</div>
          </div>
          <div style={styles.offerCard}>
            <h4>Αλλαγή Ηλεκτρικού Θερμοσίφωνα</h4>
            <div style={styles.price}>Από 70€ <span style={styles.priceNote}>(Εργασία)</span></div>
          </div>
          <div style={styles.offerCard}>
            <h4>Συντήρηση Λέβητα Αερίου</h4>
            <div style={styles.price}>Από 50€</div>
          </div>
        </div>
        <p style={styles.offersNote}>* Οι τιμές ενδέχεται να διαφέρουν ανάλογα με την πολυπλοκότητα της βλάβης.</p>
      </section>

      {/* Υποσέλιδο με Περιοχές Εξυπηρέτησης */}
      <footer style={styles.footer}>
        <div style={styles.footerContent}>
          <div style={styles.footerColumn}>
            <h4 style={styles.footerTitle}>Περιοχές που εξυπηρετούμε:</h4>
            <p style={styles.footerText}>Κέντρο Θεσσαλονίκης, Καλαμαριά, Τούμπα, Πυλαία, Χαριλάου, Τριανδρία, Εύοσμος, Σταυρούπολη και ανατολικά προάστια.</p>
          </div>
          <div style={styles.footerColumn}>
            <h4 style={styles.footerTitle}>Επικοινωνία:</h4>
            <p style={styles.footerText}>Κινητό: 6900 000 000<br/>Email: info@proplumber-thess.gr</p>
          </div>
        </div>
        <div style={styles.copyright}>
          © 2026 ProPlumber Thess. Αδειούχοι Εγκαταστάτες Υδραυλικοί.
        </div>
      </footer>

    </div>
  );
}

// Προχωρημένα Styles
const styles = {
  page: {
    backgroundColor: '#F8FAFC', // Slate 50
    minHeight: '100vh',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    scrollBehavior: 'smooth',
  },
  nav: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 5%',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    gap: '10px',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '20px',
    fontWeight: '900',
    color: '#0F172A',
    letterSpacing: '-0.5px',
  },
  logoIcon: { fontSize: '24px' },
  navPhone: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    textDecoration: 'none',
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: '15px',
    backgroundColor: '#16A34A', // Πράσινο της εμπιστοσύνης / Κλήσης
    padding: '10px 16px',
    borderRadius: '30px',
    whiteSpace: 'nowrap',
    boxShadow: '0 4px 6px rgba(22, 163, 74, 0.3)',
  },
  pulsingDot: {
    width: '8px',
    height: '8px',
    backgroundColor: '#FFFFFF',
    borderRadius: '50%',
    animation: 'pulse 1.5s infinite',
  },
  hero: {
    backgroundColor: '#0F172A',
    backgroundImage: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
    color: '#FFFFFF',
    padding: '80px 5% 60px',
    textAlign: 'center',
  },
  heroContent: {
    maxWidth: '800px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  badge: {
    backgroundColor: 'rgba(234, 88, 12, 0.2)',
    color: '#F97316',
    padding: '8px 16px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '20px',
    border: '1px solid rgba(234, 88, 12, 0.3)',
  },
  heroTitle: {
    fontSize: '40px',
    fontWeight: '900',
    margin: '0 0 20px 0',
    lineHeight: '1.2',
  },
  highlight: {
    color: '#F97316', // Πορτοκαλί για έμφαση στην ταχύτητα
  },
  heroSubtitle: {
    fontSize: '18px',
    color: '#94A3B8',
    margin: '0 0 40px 0',
    lineHeight: '1.6',
    maxWidth: '600px',
  },
  heroButtons: {
    display: 'flex',
    gap: '15px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  ctaButtonPrimary: {
    backgroundColor: '#EA580C',
    color: '#FFFFFF',
    textDecoration: 'none',
    fontSize: '18px',
    fontWeight: 'bold',
    padding: '16px 32px',
    borderRadius: '12px',
    boxShadow: '0 4px 15px rgba(234, 88, 12, 0.4)',
    whiteSpace: 'nowrap',
  },
  ctaButtonSecondary: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    color: '#FFFFFF',
    textDecoration: 'none',
    fontSize: '18px',
    fontWeight: '600',
    padding: '16px 32px',
    borderRadius: '12px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    whiteSpace: 'nowrap',
  },
  trustSection: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    flexWrap: 'wrap',
    padding: '40px 5%',
    backgroundColor: '#FFFFFF',
    marginTop: '-20px',
    position: 'relative',
    zIndex: 10,
    boxShadow: '0 10px 15px -3px rgba(0,0,0,0.05)',
  },
  trustItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '15px',
    minWidth: '200px',
  },
  trustIcon: {
    fontSize: '32px',
    marginBottom: '10px',
  },
  trustText: {
    fontSize: '13px',
    color: '#64748B',
    marginTop: '5px',
  },
  main: {
    padding: '60px 5%',
    maxWidth: '1200px',
    margin: '0 auto',
    width: '100%',
    boxSizing: 'border-box',
  },
  sectionTitle: {
    fontSize: '32px',
    color: '#0F172A',
    textAlign: 'center',
    marginBottom: '50px',
    fontWeight: '800',
  },
  sectionTitleWhite: {
    fontSize: '32px',
    color: '#FFFFFF',
    textAlign: 'center',
    marginBottom: '40px',
    fontWeight: '800',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '30px',
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '30px 20px',
    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
    border: '1px solid #E2E8F0',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  cardIcon: {
    fontSize: '35px',
    backgroundColor: '#F0F9FF',
    width: '60px',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px',
    marginBottom: '20px',
  },
  cardTitle: {
    fontSize: '20px',
    color: '#0F172A',
    marginBottom: '12px',
    fontWeight: '700',
  },
  cardText: {
    fontSize: '15px',
    color: '#475569',
    lineHeight: '1.6',
    margin: 0,
  },
  offersSection: {
    backgroundColor: '#0284C7', // Έντονο μπλε
    padding: '60px 5%',
  },
  offersGrid: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    flexWrap: 'wrap',
    maxWidth: '1000px',
    margin: '0 auto',
  },
  offerCard: {
    backgroundColor: '#FFFFFF',
    padding: '25px',
    borderRadius: '12px',
    flex: '1 1 250px',
    textAlign: 'center',
    boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
  },
  price: {
    fontSize: '28px',
    fontWeight: '900',
    color: '#0284C7',
    marginTop: '15px',
  },
  priceNote: {
    fontSize: '14px',
    color: '#64748B',
    fontWeight: 'normal',
  },
  offersNote: {
    color: '#E0F2FE',
    textAlign: 'center',
    marginTop: '30px',
    fontSize: '14px',
  },
  footer: {
    backgroundColor: '#0F172A',
    color: '#94A3B8',
    padding: '50px 5% 20px',
  },
  footerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '40px',
    justifyContent: 'space-between',
    marginBottom: '40px',
  },
  footerColumn: {
    flex: '1 1 300px',
  },
  footerTitle: {
    color: '#FFFFFF',
    fontSize: '18px',
    marginBottom: '15px',
    fontWeight: '600',
  },
  footerText: {
    lineHeight: '1.8',
    fontSize: '14px',
  },
  copyright: {
    textAlign: 'center',
    paddingTop: '20px',
    borderTop: '1px solid #1E293B',
    fontSize: '13px',
  }
};